import { _ } from '@icc/shared/helpers/b2b';

export const enum Panel {
    SuperAdmin = 'superadmin',
    Setup = 'setup',
    Company = 'company',
    IcAdmin = 'icadmin',
    Trade = 'trade',
    ComplaintB2C = 'complaintb2c',
    Driver = 'driver',
    Customer = 'customer',
    ECommerce = 'ecommerce',
    Configurator = 'configurator',
    Complaint = 'complaint',
}

export const Panels = [
    Panel.SuperAdmin,
    Panel.Setup,
    Panel.Company,
    Panel.IcAdmin,
    Panel.Trade,
    Panel.ComplaintB2C,
    Panel.Driver,
    Panel.Customer,
    Panel.ECommerce,
];
export const PanelDict = {
    [Panel.SuperAdmin]: _('PANEL|Super Admin'),
    [Panel.Setup]: _('PANEL|Instalacje'),
    [Panel.Company]: _('PANEL|Firma'),
    [Panel.IcAdmin]: _('PANEL|IC Admin'),
    [Panel.Trade]: _('PANEL|Handlowy'),
    [Panel.ComplaintB2C]: _('PANEL|Reklamacji B2C'),
    [Panel.Driver]: _('PANEL|Kierowcy'),
    [Panel.Customer]: _('PANEL|Klienta'),
    [Panel.ECommerce]: _('PANEL|eCommerce'),
}